// "use client"
//
// import { Input } from "@/components/ui/input"
// import {
// 	Select,
// 	SelectContent,
// 	SelectItem,
// 	SelectTrigger,
// 	SelectValue
// } from "@/components/ui/select"
// import { Card } from "@/components/ui/card"
// import {
// 	Tabs,
// 	TabsContent,
// 	TabsList,
// 	TabsTrigger
// } from "@/components/ui/tabs"
// import { useFormContext } from "react-hook-form"
// import {
// 	FormControl,
// 	FormField,
// 	FormItem,
// 	FormLabel,
// 	FormMessage
// } from "@/components/ui/form"
// import { nigerianBreeds } from "@/utils/items.ts"
//
// export function GrandparentalInfoForm () {
// 	const { control } = useFormContext ()
//
// 	return (
// 			<div className="space-y-6" >
// 				<h2 className="text-2xl font-bold text-center mb-6" >Grandparental
// 				                                                     Information</h2 >
//
// 				<Tabs defaultValue="paternal" className="w-full" >
// 					<TabsList className="grid w-full grid-cols-2" >
// 						<TabsTrigger value="paternal" >Paternal
// 						                               Grandparents</TabsTrigger >
// 						<TabsTrigger value="maternal" >Maternal
// 						                               Grandparents</TabsTrigger >
// 					</TabsList >
//
// 					<TabsContent value="paternal"
// 					             className="space-y-6 mt-6" >
// 						<div
// 								className="bg-slate-100 dark:bg-slate-800 p-4 rounded-lg" >
// 							<h3 className="text-lg font-semibold mb-4" >Paternal
// 							                                            Grandam
// 							                                            (Father's
// 							                                            Mother)</h3 >
// 							<div
// 									className="grid grid-cols-1 md:grid-cols-2 gap-6" >
// 								<FormField
// 										control={ control }
// 										name="paternalGrandDamName"
// 										render={ ( { field } ) => (
// 												<FormItem >
// 													<FormLabel >Name</FormLabel >
// 													<FormControl >
// 														<Input
// 																placeholder="Enter name" { ...field } />
// 													</FormControl >
// 													<FormMessage />
// 												</FormItem >
// 										) }
// 								/>
//
// 								<FormField
// 										control={ control }
// 										name="paternalGrandDamDGR"
// 										render={ ( { field } ) => (
// 												<FormItem >
// 													<FormLabel >DGR</FormLabel >
// 													<FormControl >
// 														<Input
// 																placeholder="Enter DGR" { ...field } />
// 													</FormControl >
// 													<FormMessage />
// 												</FormItem >
// 										) }
// 								/>
//
// 								<FormField
// 										control={ control }
// 										name="paternalGrandDamBreed"
// 										render={ ( { field } ) => (
// 												<FormItem >
// 													<FormLabel >Breed</FormLabel >
// 													<Select
// 															onValueChange={ field.onChange }
// 															defaultValue={ field.value } >
// 														<FormControl >
// 															<SelectTrigger >
// 																<SelectValue
// 																		placeholder="Select breed" />
// 															</SelectTrigger >
// 														</FormControl >
// 														<SelectContent
// 																className="max-h-[200px] overflow-y-auto z-50
// shadow-lg bg-white" > { nigerianBreeds.map ( ( option ) => ( <SelectItem key={
// option.breed } value={ option.breed } > { option.label } </SelectItem > ) ) }
// </SelectContent > </Select > <FormMessage /> </FormItem > ) } /> </div > </div >
// <div className="bg-slate-100 dark:bg-slate-800 p-4 rounded-lg" > <h3
// className="text-lg font-semibold mb-4" >Paternal Grandsire (Father's Father)</h3
// > <div className="grid grid-cols-1 md:grid-cols-2 gap-6" > <FormField control={
// control } name="paternalGrandSireName" render={ ( { field } ) => ( <FormItem >
// <FormLabel >Name</FormLabel > <FormControl > <Input placeholder="Enter name" {
// ...field } /> </FormControl > <FormMessage /> </FormItem > ) } />  <FormField
// control={ control } name="paternalGrandSireDGR" render={ ( { field } ) => (
// <FormItem > <FormLabel >DGR</FormLabel > <FormControl > <Input placeholder="Enter
// DGR" { ...field } /> </FormControl > <FormMessage /> </FormItem > ) } />
// <FormField control={ control } name="paternalGrandSireBreed" render={ ( { field }
// ) => ( <FormItem > <FormLabel >Breed</FormLabel > <Select onValueChange={
// field.onChange } defaultValue={ field.value } > <FormControl > <SelectTrigger >
// <SelectValue placeholder="Select breed" /> </SelectTrigger > </FormControl >
// <SelectContent className="max-h-[200px] overflow-y-auto z-50 shadow-lg bg-white"
// > { nigerianBreeds.map ( ( option ) => ( <SelectItem key={ option.breed } value={
// option.breed } > { option.label } </SelectItem > ) ) } </SelectContent > </Select
// > <FormMessage /> </FormItem > ) } /> </div > </div > </TabsContent >
// <TabsContent value="maternal" className="space-y-6 mt-6" > <div
// className="bg-slate-100 dark:bg-slate-800 p-4 rounded-lg" > <h3
// className="text-lg font-semibold mb-4" >Maternal Grandam (Mother's Mother)</h3 >
// <div className="grid grid-cols-1 md:grid-cols-2 gap-6" > <FormField control={
// control } name="maternalGrandDamName" render={ ( { field } ) => ( <FormItem >
// <FormLabel >Name</FormLabel > <FormControl > <Input placeholder="Enter name" {
// ...field } /> </FormControl > <FormMessage /> </FormItem > ) } />  <FormField
// control={ control } name="maternalGrandDamDGR" render={ ( { field } ) => (
// <FormItem > <FormLabel >DGR</FormLabel > <FormControl > <Input placeholder="Enter
// DGR" { ...field } /> </FormControl > <FormMessage /> </FormItem > ) } />
// <FormField control={ control } name="maternalGrandDamBreed" render={ ( { field }
// ) => ( <FormItem > <FormLabel >Breed</FormLabel > <Select onValueChange={
// field.onChange } defaultValue={ field.value } > <FormControl > <SelectTrigger >
// <SelectValue placeholder="Select breed" /> </SelectTrigger > </FormControl >
// <SelectContent className="max-h-[200px] overflow-y-auto z-50 shadow-lg bg-white"
// > { nigerianBreeds.map ( ( option ) => ( <SelectItem key={ option.breed } value={
// option.breed } > { option.label } </SelectItem > ) ) } </SelectContent > </Select
// > <FormMessage /> </FormItem > ) } /> </div > </div >  <div
// className="bg-slate-100 dark:bg-slate-800 p-4 rounded-lg" > <h3
// className="text-lg font-semibold mb-4" >Maternal Grandsire (Mother's Father)</h3
// > <div className="grid grid-cols-1 md:grid-cols-2 gap-6" > <FormField control={
// control } name="maternalGrandSireName" render={ ( { field } ) => ( <FormItem >
// <FormLabel >Name</FormLabel > <FormControl > <Input placeholder="Enter name" {
// ...field } /> </FormControl > <FormMessage /> </FormItem > ) } />  <FormField
// control={ control } name="maternalGrandSireDGR" render={ ( { field } ) => (
// <FormItem > <FormLabel >DGR</FormLabel > <FormControl > <Input placeholder="Enter
// DGR" { ...field } /> </FormControl > <FormMessage /> </FormItem > ) } />
// <FormField control={ control } name="maternalGrandSireBreed" render={ ( { field }
// ) => ( <FormItem > <FormLabel >Breed</FormLabel > <Select onValueChange={
// field.onChange } defaultValue={ field.value } > <FormControl > <SelectTrigger >
// <SelectValue placeholder="Select breed" /> </SelectTrigger > </FormControl >
// <SelectContent className="max-h-[200px] overflow-y-auto z-50 shadow-lg bg-white"
// > { nigerianBreeds.map ( ( option ) => ( <SelectItem key={ option.breed } value={
// option.breed } > { option.label } </SelectItem > ) ) } </SelectContent > </Select
// > <FormMessage /> </FormItem > ) } /> </div > </div > </TabsContent > </Tabs >
// <Card className="p-4 bg-slate-50 dark:bg-slate-800 border-slate-200
// dark:border-slate-700" > <p className="text-sm text-slate-600
// dark:text-slate-400" > Grandparental information provides deeper insight into the
// animal's genetic lineage. This information is valuable for advanced breeding
// programs and genetic analysis. </p > </Card > </div > ) }

"use client";

import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useFormContext } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { CalendarIcon, Crown, Users } from "lucide-react";
import { format } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn, formatDate } from "@/lib/utils";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ImageUpload } from "@/components/ui/image-upload";
import { nigerianBreeds } from "@/utils/items.ts";

type GrandParentalInfoFormProps = {
  setPaternalGrandfatherImageFile: (file: File) => void;
  setPaternalGrandmotherImageFile: (file: File) => void;
  setMaternalGrandfatherImageFile: (file: File) => void;
  setMaternalGrandmotherImageFile: (file: File) => void;
};

export function GrandParentalInfoForm({
  setPaternalGrandfatherImageFile,
  setPaternalGrandmotherImageFile,
  setMaternalGrandfatherImageFile,
  setMaternalGrandmotherImageFile,
}: GrandParentalInfoFormProps) {
  // Fix: Destructure useFormContext at the top so control, setValue, and watch are
  // defined
  const { control, setValue, watch } = useFormContext();

  // State for all grandparent birth dates
  const [dates, setDates] = useState({
    paternalGrandDam: watch("paternalGrandDamBirthDate")
      ? new Date(watch("paternalGrandDamBirthDate"))
      : undefined,
    paternalGrandSire: watch("paternalGrandSireBirthDate")
      ? new Date(watch("paternalGrandSireBirthDate"))
      : undefined,
    maternalGrandDam: watch("maternalGrandDamBirthDate")
      ? new Date(watch("maternalGrandDamBirthDate"))
      : undefined,
    maternalGrandSire: watch("maternalGrandSireBirthDate")
      ? new Date(watch("maternalGrandSireBirthDate"))
      : undefined,
  });

  const handleDateSelect = (
    dateKey: keyof typeof dates,
    fieldName: string,
    date: Date | undefined,
  ) => {
    setDates((prev) => ({ ...prev, [dateKey]: date }));
    if (date) {
      setValue(fieldName, formatDate(date));
    }
  };

  type GrandparentSectionProps = {
    title: string;
    nameField: string;
    dgrField: string;
    breedField: string;
    birthDateField: string;
    imageField: string;
    setImageFile: (file: File) => void;
    dateKey: keyof typeof dates;
    colorScheme: "purple" | "green";
  };

  const renderGrandparentSection = ({
    title,
    nameField,
    dgrField,
    breedField,
    birthDateField,
    imageField,
    setImageFile,
    dateKey,
    colorScheme,
  }: GrandparentSectionProps) => {
    const colorClasses = {
      purple: {
        bg: "bg-purple-50 dark:bg-purple-950/20",
        border: "border-purple-200 dark:border-purple-800",
        text: "text-purple-900 dark:text-purple-100",
        icon: "text-purple-600",
      },
      green: {
        bg: "bg-green-50 dark:bg-green-950/20",
        border: "border-green-200 dark:border-green-800",
        text: "text-green-900 dark:text-green-100",
        icon: "text-green-600",
      },
    };
    const colors = colorClasses[colorScheme];

    return (
      <div className={`${colors.bg} p-6 rounded-lg border ${colors.border}`}>
        <div className="flex items-center gap-2 mb-6">
          <Crown className={`h-5 w-5 ${colors.icon}`} />
          <h3 className={`text-lg font-semibold ${colors.text}`}>{title}</h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="space-y-6">
            <FormField
              control={control}
              name={nameField}
              render={({ field }) => (
                <FormItem>
                  <FormLabel className={"text-[#008c8fff]"}>Name</FormLabel>
                  <FormControl>
                    <Input placeholder="Enter name" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={control}
              name={dgrField}
              render={({ field }) => (
                <FormItem>
                  <FormLabel className={"text-[#008c8fff]"}>DGR</FormLabel>
                  <FormControl>
                    <Input placeholder="Enter DGR" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={control}
              name={birthDateField}
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel className={"text-[#008c8fff]"}>
                    Date of birth
                  </FormLabel>
                  <Popover>
                    <PopoverTrigger asChild>
                      <FormControl>
                        <Button
                          variant="outline"
                          className={cn(
                            "w-full pl-3 text-left font-normal",
                            !dates[dateKey] && "text-muted-foreground",
                          )}
                        >
                          <CalendarIcon className="mr-2 h-4 w-4" />
                          {dates[dateKey] ? (
                            format(dates[dateKey]!, "PPP")
                          ) : (
                            <span>Select date</span>
                          )}
                        </Button>
                      </FormControl>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-0" align="start">
                      <Calendar
                        mode="single"
                        selected={
                          field.value ? new Date(field.value) : undefined
                        }
                        onSelect={(date) =>
                          handleDateSelect(dateKey, birthDateField, date)
                        }
                        disabled={(date: any) =>
                          date > new Date() || date < new Date("1900-01-01")
                        }
                        captionLayout="dropdown"
                      />
                    </PopoverContent>
                  </Popover>
                  <FormMessage />
                </FormItem>
              )}
            />

            {/* <FormField */}
            {/*   control={control} */}
            {/*   name={birthDateField} */}
            {/*   render={() => ( */}
            {/*     <FormItem className="flex flex-col"> */}
            {/*       <FormLabel className={"text-[#008c8fff]"}>Birth Date</FormLabel> */}
            {/*       <Popover> */}
            {/*         <PopoverTrigger asChild> */}
            {/*           <FormControl> */}
            {/*             <Button */}
            {/*               variant="outline" */}
            {/*               className={cn( */}
            {/*                 "w-full pl-3 text-left font-normal", */}
            {/*                 !dates[dateKey] && "text-muted-foreground", */}
            {/*               )} */}
            {/*             > */}
            {/*               <CalendarIcon className="mr-2 h-4 w-4" /> */}
            {/*               {dates[dateKey] ? ( */}
            {/*                 format(dates[dateKey]!, "PPP") */}
            {/*               ) : ( */}
            {/*                 <span>Select date</span> */}
            {/*               )} */}
            {/*             </Button> */}
            {/*           </FormControl> */}
            {/*         </PopoverTrigger> */}
            {/*         <PopoverContent */}
            {/*           className="w-auto p-0" */}
            {/*           align="start" */}
            {/*           side="bottom" */}
            {/*         > */}
            {/*           <Calendar */}
            {/*             mode="single" */}
            {/*             selected={dates[dateKey]} */}
            {/*             onSelect={(date) => */}
            {/*               handleDateSelect(dateKey, birthDateField, date) */}
            {/*             } */}
            {/*             initialFocus */}
            {/*             disabled={(date) => date > new Date()} */}
            {/*           /> */}
            {/*         </PopoverContent> */}
            {/*       </Popover> */}
            {/*       <FormMessage /> */}
            {/*     </FormItem> */}
            {/*   )} */}
            {/* /> */}
            <FormField
              control={control}
              name={breedField}
              render={({ field }) => (
                <FormItem>
                  <FormLabel className={"text-[#008c8fff]"}>Breed</FormLabel>
                  <Select
                    onValueChange={field.onChange}
                    defaultValue={field.value}
                  >
                    <FormControl>
                      <SelectTrigger>
                        <SelectValue placeholder="Select breed" />
                      </SelectTrigger>
                    </FormControl>
                    <SelectContent
                      position="popper"
                      className="max-h-[300px] overflow-y-auto z-50 shadow-lg bg-white "
                    >
                      {nigerianBreeds.map((option) => (
                        <SelectItem
                          key={option.breed}
                          value={option.breed}
                          className={"overflow-y-auto z-50 background-white"}
                        >
                          {option.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div>
            <FormField
              control={control}
              name={imageField}
              render={({ field }) => (
                <FormItem>
                  <FormLabel className={"text-[#008c8fff]"}>Image</FormLabel>
                  <FormControl>
                    <ImageUpload
                      value={field.value}
                      onChange={(file) => {
                        field.onChange(file);
                        if (file instanceof File) {
                          setImageFile(file);
                        }
                      }}
                      description={`Add a photo of the ${title.toLowerCase()}`}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </div>
      </div>
    );
  };

  // Wrap the return in a single parent div
  return (
    <div>
      <div className="space-y-6">
        <div className="text-center space-y-2">
          <div className="flex items-center justify-center gap-2">
            <Users className="h-6 w-6 text-amber-600" />
            <h2 className="text-2xl font-bold">Grandparental Information</h2>
          </div>
          <p className="text-muted-foreground">
            Third generation ancestry records with visual documentation
          </p>
        </div>
        <Tabs defaultValue="paternal" className="w-full">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="paternal" className="flex items-center gap-2">
              <Crown className="h-4 w-4" />
              Paternal Grandparents
            </TabsTrigger>
            <TabsTrigger value="maternal" className="flex items-center gap-2">
              <Crown className="h-4 w-4" />
              Maternal Grandparents
            </TabsTrigger>
          </TabsList>
          <TabsContent value="paternal" className="space-y-6 mt-6">
            <div className="space-y-6">
              {renderGrandparentSection({
                title: "Paternal Grandam (Father's Mother)",
                nameField: "paternalGrandDamName",
                dgrField: "paternalGrandDamDGR",
                breedField: "paternalGrandDamBreed",
                birthDateField: "paternalGrandDamBirthDate",
                imageField: "paternalGrandDamImage",
                setImageFile: setPaternalGrandmotherImageFile,
                dateKey: "paternalGrandDam",
                colorScheme: "purple",
              })}
              {renderGrandparentSection({
                title: "Paternal Grandsire (Father's Father)",
                nameField: "paternalGrandSireName",
                dgrField: "paternalGrandSireDGR",
                breedField: "paternalGrandSireBreed",
                birthDateField: "paternalGrandSireBirthDate",
                imageField: "paternalGrandSireImage",
                setImageFile: setPaternalGrandfatherImageFile,
                dateKey: "paternalGrandSire",
                colorScheme: "green",
              })}
            </div>
          </TabsContent>
          <TabsContent value="maternal" className="space-y-6 mt-6">
            <div className="space-y-6">
              {renderGrandparentSection({
                title: "Maternal Grandam (Mother's Mother)",
                nameField: "maternalGrandDamName",
                dgrField: "maternalGrandDamDGR",
                breedField: "maternalGrandDamBreed",
                birthDateField: "maternalGrandDamBirthDate",
                imageField: "maternalGrandDamImage",
                setImageFile: setMaternalGrandmotherImageFile,
                dateKey: "maternalGrandDam",
                colorScheme: "purple",
              })}
              {renderGrandparentSection({
                title: "Maternal Grandsire (Mother's Father)",
                nameField: "maternalGrandSireName",
                dgrField: "maternalGrandSireDGR",
                breedField: "maternalGrandSireBreed",
                birthDateField: "maternalGrandSireBirthDate",
                imageField: "maternalGrandSireImage",
                setImageFile: setMaternalGrandfatherImageFile,
                dateKey: "maternalGrandSire",
                colorScheme: "green",
              })}
            </div>
          </TabsContent>
        </Tabs>
        <Card className="p-4 bg-amber-50 dark:bg-amber-950/20 border-amber-200 dark:border-amber-800">
          <div className="flex items-start gap-3">
            <Users className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
            <div className="space-y-2">
              <h4 className="font-medium text-amber-900 dark:text-amber-100">
                Grandparental Information Guidelines
              </h4>
              <p className="text-sm text-amber-700 dark:text-amber-200">
                Grandparental information provides deeper insight into the
                animal's genetic lineage. This information is valuable for
                advanced breeding programs and genetic analysis. Visual
                documentation helps with identification and maintains historical
                records. Use the tabs above to organize information by paternal
                and maternal lineages.
              </p>
              <div className="text-xs text-amber-600 dark:text-amber-300">
                <p>
                  <strong>Tip:</strong> Complete grandparental records improve
                  genetic evaluation accuracy and breeding program
                  effectiveness.
                </p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
